<div class="d-lg-none d-block widget-mobile pt-3 container">
  <fgb-navigation-pills [navItems]="jetCashNavItems" />
</div>

<div class="container mt-4">
  <div class="d-lg-none d-block">
    <h5 class="mb-3 profile-title fw-light-bold font-page-heading">
      {{ 'transaction.history.title' | translate }}
    </h5>
    <fgb-transaction-history [transactionTypes]="[transactionTypes.payment]" [ecashView]="true"></fgb-transaction-history>
  </div>
</div>
